export default {
  refresh: 'Refresh',
  close: 'Close',
  closeOthers: 'Close Others',
  closeAll: 'Close All'
}
